import { fromJS } from 'immutable';

const TITLE_CHANGE = 'app/TITLE_CHANGE';

const initialState = fromJS({
  title: 'Udlejning', // TODO: use i18n ?
  loading: false
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case TITLE_CHANGE:
      return state.set('title', action.payload);
    default:
      return state;
  }
}

export function setTitle(payload = initialState.get('title')) {
  return { type: TITLE_CHANGE, payload };
}
